/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CustomTextV1Dto } from './CustomTextV1Dto';
import type { FieldCheckboxV1Dto } from './FieldCheckboxV1Dto';
import type { FieldMentionV1Dto } from './FieldMentionV1Dto';
import type { FieldRadioGroupV1Dto } from './FieldRadioGroupV1Dto';
import type { FieldSignatureV1Dto } from './FieldSignatureV1Dto';
import type { FieldTextV1Dto } from './FieldTextV1Dto';
import type { RedirectUrlsV1Dto } from './RedirectUrlsV1Dto';
export type SignerFromExistingContactV1Dto = {
  /**
   * The custom text of the template
   */
  custom_text?: CustomTextV1Dto;
  /**
   * The delivery mode of the template
   */
  delivery_mode?: SignerFromExistingContactV1Dto.delivery_mode;
  /**
   * Fields assigned to the signer
   */
  fields: Array<
    | FieldSignatureV1Dto
    | FieldTextV1Dto
    | FieldMentionV1Dto
    | FieldCheckboxV1Dto
    | FieldRadioGroupV1Dto
  > | null;
  /**
   * The redirect urls of the template
   */
  redirect_urls?: RedirectUrlsV1Dto;
  /**
   * The level of the signature
   */
  signature_level?: SignerFromExistingContactV1Dto.signature_level;
  /**
   * The signature authentication mode
   */
  signature_authentication_mode?: SignerFromExistingContactV1Dto.signature_authentication_mode | null;
  /**
   * The contact id of the template
   */
  contact_id: string;
};
export namespace SignerFromExistingContactV1Dto {
  /**
   * The delivery mode of the template
   */
  export enum delivery_mode {
    EMAIL = 'email',
    NONE = 'none',
  }
  /**
   * The level of the signature
   */
  export enum signature_level {
    ELECTRONIC_SIGNATURE = 'electronic_signature',
    ADVANCED_ELECTRONIC_SIGNATURE = 'advanced_electronic_signature',
    QUALIFIED_ELECTRONIC_SIGNATURE = 'qualified_electronic_signature',
  }
  /**
   * The signature authentication mode
   */
  export enum signature_authentication_mode {
    OTP_EMAIL = 'otp_email',
    OTP_SMS = 'otp_sms',
    NO_OTP = 'no_otp',
  }
}
